<template>
  <!-- don't show if study has 1 language... or less somehow -->
  <div class="ui dropdown" v-if="langSelection.length > 1">
    <button class="dropbtn" @click="showDropdown = !showDropdown">
      <i class="ui language icon" />
      {{ userLang.toUpperCase() }}
      <i class="triangle down icon"/>
    </button>
    <div v-if="showDropdown" class="dropdown-content">
      <a v-for="language in langSelection" @click="updateUserLang(language); showDropdown = false" :key="language">{{ language.toUpperCase() }}<br></a>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'LanguageToggle',
  data () {
    return {
      showDropdown: false
    }
  },
  computed: {
    langSelection: function () {
      if (this.chosenStudy !== null) {
        return (this.chosenStudy.languages)
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapActions(['updateUserLang'])
  }
}

</script>

<style scoped>
.dropbtn {
  background-color: #6496BB !important;
  color: white;
  padding: 1em;
  min-height: 3em;
  max-height: 3em;
  font-size: 1em;
  border: none;
  cursor: pointer;
  position: relative;
  float: right;
  border-radius: 0.5em;
}

.dropbtn:focus {
  outline: none;
}

.dropdown {
  width: 100%;
  position: relative;
  display: inline-block;
  margin-bottom: 1rem;
}

.dropdown-content {
  position: absolute;
  right: 0;
  top: 3em;
  background-color: #f9f9f9;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #f1f1f1
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}
</style>
